import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core'
import { Button } from '@mui/material'
import { YES } from 'src/utils/constants/Ceo'

const ConfirmationModal = ({
  message,
  open,
  buttonName,
  onClose,
  onSubmit,
}) => {
  return (
    <Dialog open={open} onClose={onClose} id='confirmationDialog'>
      <DialogContent>
        <DialogContentText id='confirmationText'>{message}</DialogContentText>
      </DialogContent>
      <DialogActions id='confirmationActions'>
        <Button variant='outlined' onClick={onClose} id='noButton'>
          No
        </Button>
        <Button variant='outlined' onClick={onSubmit} id='submitButton'>
          {buttonName ? buttonName : YES}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationModal
